module.exports = __webpack_public_path__ + "img/Payoneer.73982471.png";